import { render, staticRenderFns } from "./ModalBox.vue?vue&type=template&id=4bb528d8&"
import script from "./ModalBox.vue?vue&type=script&lang=ts&"
export * from "./ModalBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports